import _ from "lodash";
import { useEffect, useState } from "react";
import { Box, Divider, InputLabel, Radio, RadioGroup } from "@mui/material";
import ErrorAlert from "../../../../toolkit/ErrorAlert";
import Button from "../../../../toolkit/Button";
import FormControl from "../../../../components/FormControl";
import useFetch from "../../../../utils/useFetch";
import Delayed from "../../../../utils/Delayed";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useCallback, useContext } from "react";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Label from "../../../../toolkit/Label";
import axios from "../../../../utils/fvAxios";
import { FormLabel } from "react-bootstrap";

import FormControlMUI from "@mui/material/FormControl";
import FormLabelMUI from "@mui/material/FormLabel";
import { UsersContext } from "../../../../store/users-context";

const queryUrl =
  "/SystemUser/GetOrganisations?hasPaginationOn=false&pageSize=10&pageNumber=1";

const filter = createFilterOptions();
const searchDebounceDelay = 1000;
const defaultSelections = {
  clientIds: [],
  superClientIds: [],
  adminIds: [],
  venderName: {},
  userStatusActive: false,
  userStatusInactive: false,
};
export default function UserFilters({ ...props }) {
  const {
    setFilterSelections,
    lastSavedSelections,
    filterIsOpened,
    setFilterIsOpened,
  } = useContext(UsersContext);

  const [selections, setSelections] = useState(lastSavedSelections);

  const [activeInactiveCheckbox, setActiveInactiveCheckbox] = useState("");
  const [adminData, setAdminData] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [supClientData, setSupClientData] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [enableSaveButton, setEnableSaveButton] = useState(false);
  function filterChangeHandler(filterObj) {
    console.log("filterChangeHandler");
    props.filterChangeHandler(filterObj);
    setFilterSelections(filterObj);
    setFilterIsOpened(false);
  }
  const { data: adminsData } = useFetch(queryUrl + "&orgType=Admin");
  const { data: clientsData } = useFetch(queryUrl + "&orgType=Client");
  const { data: superclientsData } = useFetch(
    queryUrl + "&orgType=Super%20Client"
  );

  const [value, setValue] = useState(null);
  const [vendorSearchStr, setVendorSearchStr] = useState("");

  const getFilteredVendors = async (str) => {
    await axios
      .get(queryUrl + "&orgType=Vendor&searchValue=" + str?.text)
      .then((resp) => {
        setVendorData(getOrganizations(resp?.data?.data));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getOrganizations = useCallback((responseData) => {
    let organizations = [];
    responseData?.forEach((pair) => {
      organizations.push(optionsDataMapper(pair));
    });
    return organizations;
  }, []);

  useEffect(() => {
    let adminOrgs = adminsData?.data ? [...adminsData?.data] : undefined;
    let clientsOrgs = clientsData?.data ? [...clientsData?.data] : undefined;
    let scOrgs = superclientsData?.data
      ? [...superclientsData?.data]
      : undefined;
    if (adminOrgs) setAdminData(getOrganizations(adminOrgs));
    if (clientsOrgs) setClientData(getOrganizations(clientsOrgs));
    if (scOrgs) setSupClientData(getOrganizations(scOrgs));
  }, [adminsData, clientsData, superclientsData]);

  function optionsDataMapper({ key, value }) {
    return {
      value: key,
      text: value,
    };
  }

  const debouncedSearchQueryHandler = useCallback(
    _.debounce(getFilteredVendors, searchDebounceDelay),
    []
  );

  useEffect(() => {
    if (vendorSearchStr !== value) {
      setVendorSearchStr(value);
      if (value && value.text.length > 2) {
        debouncedSearchQueryHandler(value);
      } else setVendorData([]);
    } else {
    }
  }, [value]);

  useEffect(() => {
    setEnableSaveButton(false);
  }, [filterIsOpened]);

  function handleChange(field, data) {
    const newSelections = _.cloneDeep(selections);
    let name = "";
    if (field === "Admin") {
      field = "adminIds";
    }
    if (field === "Vendor") {
      field = "vendorIds";
      name = data?.text;
      data = data?.value;
    }
    if (field === "Client") {
      field = "clientIds";
    }
    if (field === "Super Client") {
      field = "superClientIds";
    }
    if (field === "userStatusActive" || field === "userStatusInactive") {
      if (field === "userStatusActive") {
        newSelections.userStatusInactive = false;
        newSelections.userStatusActive = !newSelections.userStatusActive;
        newSelections.userStatusActive
          ? setActiveInactiveCheckbox("userStatusActive")
          : setActiveInactiveCheckbox("");
      } else if (field === "userStatusInactive") {
        newSelections.userStatusActive = false;
        newSelections.userStatusInactive = !newSelections.userStatusInactive;
        newSelections.userStatusInactive
          ? setActiveInactiveCheckbox("userStatusInactive")
          : setActiveInactiveCheckbox("");
      }
      const modifiedSelection = { ...newSelections };
      setSelections(modifiedSelection);
      if (_.isEqual(lastSavedSelections, modifiedSelection)) {
        setEnableSaveButton(false);
      } else setEnableSaveButton(true);
    } else {
      let modifiedSelection = { ...newSelections, [field]: data };
      if (name) {
        modifiedSelection = { ...modifiedSelection, ["vendorName"]: name };
      }else{
        modifiedSelection = { ...modifiedSelection, ["vendorName"]: null };
      }
      setSelections(modifiedSelection);
      if (_.isEqual(lastSavedSelections, modifiedSelection)) {
        setEnableSaveButton(false);
      } else setEnableSaveButton(true);
    }
  }

  function resetSelections() {
    setSelections(defaultSelections);
    setValue(null);
    setActiveInactiveCheckbox("");
    filterChangeHandler(defaultSelections);
    setFilterIsOpened(true);
    setEnableSaveButton(false);
  }
  function resetToPreviousSelections() {
    setSelections(defaultSelections);
    setValue(null);
    setActiveInactiveCheckbox("");
  }

  useEffect(() => {
    if (filterIsOpened) {
      setSelections(lastSavedSelections);
      // setActiveInactiveCheckbox(lastSavedSelections.userStatusActive);
      if (lastSavedSelections.userStatusActive)
        setActiveInactiveCheckbox("userStatusActive");
      else if (lastSavedSelections.userStatusInactive)
        setActiveInactiveCheckbox("userStatusInactive");
    }
    if(!filterIsOpened){
      // setValue({text: lastSavedSelections?.vendorName,})   
      if(!lastSavedSelections?.vendorName){
        setValue(null);
      }
      if (lastSavedSelections.userStatusActive)
      setActiveInactiveCheckbox("userStatusActive");
    else if (lastSavedSelections.userStatusInactive)
      setActiveInactiveCheckbox("userStatusInactive");  
      else{
        setActiveInactiveCheckbox("")
      }
    }
    lastSavedSelections?.vendorName &&
      setValue({
        text: lastSavedSelections?.vendorName,
      });

  }, [filterIsOpened]);

  const autoCompleteChangeHandler = (event) => {
    let newValue = event.target.value;
    if (typeof newValue === "string") {
      setValue({
        text: newValue,
      });
    } else if (newValue) {
      setValue({
        text: newValue,
      });
    } else {
      setValue(newValue);
    }
  };

  return (
    <Box className="filters-container">
      <Box>
        <Box>
          <>
            <Box>
              <FormLabel
                id="controlled-radio-buttons-group"
                style={{ fontSize: "0.9em" }}
              >
                Status:
              </FormLabel>
              <RadioGroup
                aria-labelledby="controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={activeInactiveCheckbox}
                onClick={(event) =>
                  handleChange(event.target.value, event.target.checked)
                }
                // onChange={(event) =>
                //   handleChange(event.target.value, event.target.checked)
                // }
              >
                <FormControlLabel
                  style={{ fontSize: "0.9em" }}
                  value={"userStatusActive"}
                  control={<Radio />}
                  label="Active"
                />
                <FormControlLabel
                  style={{ fontSize: "0.9em" }}
                  value={"userStatusInactive"}
                  control={<Radio />}
                  label="Disabled"
                />
              </RadioGroup>
            </Box>
            <Box>
              <FormControl
                fieldId={"Admin"}
                required={false}
                label={"Admin"}
                inputType="select"
                multiple={true}
                items={adminData}
                value={selections?.adminIds || ""}
                handleChange={(value) => handleChange("Admin", value)}
                width={"100%"}
                disabled={false}
                heighlight={"false"}
              />
              <FormControl
                fieldId={"Client"}
                required={false}
                label={"Client"}
                inputType="select"
                multiple={true}
                items={clientData}
                value={selections?.clientIds || ""}
                handleChange={(value) => handleChange("Client", value)}
                width={"100%"}
                disabled={false}
                heighlight={"false"}
              />
              <FormControl
                fieldId={"SuperClient"}
                required={false}
                label={"Super Client"}
                inputType="select"
                multiple={true}
                items={supClientData}
                value={selections?.superClientIds || ""}
                handleChange={(value) => handleChange("Super Client", value)}
                width={"100%"}
                disabled={false}
                heighlight={"false"}
              />
              <InputLabel sx={{ color: "black" }} style={{ fontSize:"0.9em" }}>
                {"Vendor(type atleast three characters)"}
              </InputLabel>
              <Autocomplete
                value={value}
                onInput={autoCompleteChangeHandler}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setValue({
                      text: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    setValue({
                      text: newValue.inputValue,
                    });
                  } else {
                    setValue(newValue);
                  }
                  handleChange("Vendor", newValue);
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);
                  const { inputValue } = params;
                  const isExisting = options?.some((option) =>
                    option.text.includes(inputValue)
                  );
                  // if (inputValue !== "" && !isExisting) {
                  //   filtered.push({
                  //     inputValue,
                  //     text: `Add "${inputValue}"`,
                  //   });
                  // }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="vendorAutocomplete"
                noOptionsText="No Vendors"
                options={vendorData}
                getOptionLabel={(option) => {
                  if (typeof option === "string") {
                    return option;
                  }
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  return option?.text;
                }}
                renderOption={(props, option, state) => (
                  <li {...props} key={state.index}>
                    {option.text}
                  </li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => <TextField {...params} />}
              />
            </Box>
          </>
        </Box>
        <Box sx={{ flexGrow: 1, display: "flex" }} />
        <Divider />
        <Box className="footer">
          <Button
            size="small"
            label="Clear Filters"
            role="secondary"
            onClick={resetSelections}
          />
          <Button
            size="small"
            label="Save Filters"
            disabled={!enableSaveButton}
            onClick={() => filterChangeHandler(selections)}
          />
        </Box>
      </Box>
    </Box>
  );
}
